module.exports = __webpack_public_path__ + "img/travel-1.4a8e6984.jpeg";